import React from "react";
import { Box, TextField } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import AdapterJalaali from "@date-io/jalaali";
import moment from "moment-jalaali";

moment.loadPersian({
  dialect: "persian-modern",
  usePersianDigits: true,
});

function PersianDatePicker({
  year,
  setYear,
  month,
  setMonth,
  day,
  setDay,
  withDay = false,
}) {
  const value =
    year?.year && month?.month
      ? moment(`${year.year}/${month.month}/${day?.day || 1}`, "jYYYY/jM/jD")
      : moment();

  return (
    <LocalizationProvider dateAdapter={AdapterJalaali}>
      <Box sx={{ flex: 1, minWidth: 160 }}>
        <DatePicker
          views={withDay ? ["year", "month", "day"] : ["year", "month"]}
          label={withDay ? "انتخاب تاریخ" : "انتخاب ماه و سال"}
          value={value}
          minDate={moment("1278/01/01", "jYYYY/jMM/jDD")}
          maxDate={moment("1478/12/29", "jYYYY/jMM/jDD")}
          onChange={(newValue) => {
            if (!newValue) return;

            setYear({ year: newValue.jYear().toString() });
            setMonth({ month: newValue.jMonth() + 1 });

            if (withDay && setDay) {
              setDay({ day: newValue.jDate() });
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              fullWidth
              InputProps={{
                ...params.InputProps,
                style: { textAlign: "right" },
              }}
            />
          )}
        />
      </Box>
    </LocalizationProvider>
  );
}

export default PersianDatePicker;
